var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clock_svg__clip0_31_3092)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 0a7 7 0 107 7 7.008 7.008 0 00-7-7zm0 12.923A5.923 5.923 0 1112.923 7 5.93 5.93 0 017 12.923zM11.308 7a.538.538 0 01-.539.538H7A.538.538 0 016.462 7V3.23a.538.538 0 111.076 0v3.232h3.231a.539.539 0 01.539.538z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clock_svg__clip0_31_3092"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h14v14H0z"
  })))));
}
export default SvgClock;